import { type QueryClient } from '@tanstack/react-query';

/**
 * Làm mới mọi màn hình có thể đang hiện việc của một dự án — sau khi xoá hay
 * khôi phục việc (APM-TDEL-b).
 *
 * Một việc có mặt ở rất nhiều chỗ: bảng, backlog, Gantt, danh sách, "Việc của
 * tôi", tab Thay đổi… mỗi chỗ một khoá cache. Liệt kê từng khoá là chắc chắn
 * quên một chỗ ở lần thêm màn hình tiếp theo, và chỗ bị quên sẽ hiện một việc
 * đã xoá cho tới lần tải lại trang. Nên ở đây làm mới mọi query có `projectId`
 * trong khoá, cộng các danh sách cá nhân (`['me', …]`) vốn không mang nó.
 */
export function invalidateProjectTasks(queryClient: QueryClient, projectId: string): void {
  void queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey.includes(projectId) ||
      query.queryKey[0] === 'me' ||
      query.queryKey[0] === 'task',
  });
}
